import { supabase } from './supabase'

// Opens (or reuses) a direct-message conversation with another user, not
// tied to a listing. Conversations are stored as 'enquiry' rows in bookings.
// Returns the conversation id, or throws with a readable message.
export async function startDirectMessage(fromUserId, toUserId) {
  const { data: existing } = await supabase
    .from('bookings')
    .select('id')
    .is('listing_id', null)
    .eq('hirer_id', fromUserId)
    .eq('owner_id', toUserId)
    .eq('status', 'enquiry')
    .limit(1)
    .maybeSingle()
  if (existing?.id) return existing.id
  const { data, error } = await supabase.from('bookings').insert({
    listing_id: null,
    hirer_id: fromUserId,
    owner_id: toUserId,
    start_date: new Date().toISOString().split('T')[0],
    hours: 1,
    total_amount: 0,
    platform_fee: 0,
    owner_payout: 0,
    deposit_amount: 0,
    status: 'enquiry',
    notes: null,
  }).select().single()
  if (error) throw new Error(error.message)
  return data.id
}
